<script setup lang="ts">
/**
 * Верхняя панель экрана — макет 34:249: высота 48, крошки слева с отступом 20,
 * действия справа. Наполнение у каждого экрана своё (10 контекстов в макете),
 * поэтому здесь только каркас со слотами.
 */
defineProps<{
  /** Крошки: последняя — текущий экран, её не делаем ссылкой */
  breadcrumbs?: { label: string; to?: string }[]
}>()
</script>

<template>
  <header class="toolbar">
    <nav v-if="breadcrumbs?.length" class="toolbar__breadcrumbs">
      <template v-for="(crumb, index) in breadcrumbs" :key="crumb.label">
        <span v-if="index > 0" class="toolbar__separator">/</span>
        <RouterLink v-if="crumb.to" class="toolbar__crumb" :to="crumb.to">
          {{ crumb.label }}
        </RouterLink>
        <span v-else class="toolbar__crumb toolbar__crumb--current">{{ crumb.label }}</span>
      </template>
    </nav>

    <slot name="breadcrumbs" />

    <div class="toolbar__actions">
      <slot />
    </div>
  </header>
</template>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  height: 48px;
  padding: 0 20px;
  border-bottom: 1px solid var(--color-border);
  background-color: var(--color-bg-muted);
}

.toolbar__breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-body);
}

.toolbar__crumb {
  color: var(--color-text-muted);
  text-decoration: none;
}

.toolbar__crumb:hover {
  color: var(--color-text-primary);
}

.toolbar__crumb--current {
  color: var(--color-text-primary);
  font-weight: 500;
}

.toolbar__separator {
  color: var(--color-text-muted);
}

.toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
</style>
